<p><button *ngIf="!web3Service.accounts.length" (click)="connectWallet()">Connect</button></p>